import _ from 'lodash'
import {mapState, mapActions} from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      params: {},
      supportedFilters: ['multi-select'],
      registeredFilters: [],
    }
  },
  computed: {
    ...mapState(['groupedRewards']),
    category() {
      return _.get(this.data, 'rewardsCategory', '')
    },
    title() {
      return _.get(this.data, 'title', this.defaultTitle)
    },
    rewards() {
      if (_.isEmpty(this.groupedRewards)) {
        return []
      }

      if (_.isEmpty(this.category)) {
        return this.groupedRewards[this.defaultGroup]
      }

      return this.groupedRewards[this.category]
    },
    filters() {
      return _.get(this.data, 'filters', [])
    },
    query() {
      if (_.isEmpty(this.params)) {
        return ''
      }

      let queryString = ''
      const paramKeys = Object.keys(this.params)

      for (let i = 0; i < paramKeys.length; i++) {
        if (i === 0) {
          queryString += '?'
        } else {
          queryString += '&'
        }

        const paramKey = paramKeys[i]

        queryString += `${paramKey}=${this.params[paramKey]}`
      }

      return queryString
    },
    titleCustomStyle() {
      return _.get(this.data, 'style.title', null)
    },
    bountyCustomStyle() {
      return _.get(this.data, 'style.bounty', null)
    },
    filtersCustomStyle() {
      return _.get(this.data, 'style.filter_buttons', null)
    }
  },
  mounted() {
    if (!_.isEmpty(this.category)) {
      this.$set(this.params, 'category', this.category)
    }

    if (_.isEmpty(this.filters)) {
      this.fetchRewards()
    }
  },
  methods: {
    ...mapActions(['getRewardsByCategory']),
    async fetchRewards() {
      this.loading = true
      try {
        const category = _.isEmpty(this.category)
          ? this.defaultGroup
          : this.category

        await this.getRewardsByCategory({
          group: category,
          query: this.query
        })
        this.loading = false
      } catch (error) {
        this.loading = false
        console.warn("Error fetching rewards: " + error)
      }
    },
    generateFilterQuery() {
      const filterQuery = {}
      const filters = this.registeredFilters

      if (!_.isArray(filters) || _.isEmpty(filters)) {
        return JSON.stringify(filterQuery)
      }

      filters.forEach((filter) => {
        const attribute = _.get(filter, 'attribute', null)
        const type = _.get(filter, 'type', null)

        if (!this.supportedFilters.includes(type)) {
          return
        }

        if (!attribute || !type) {
          return
        }

        if (type === 'multi-select') {
          const options = _.get(filter, 'options', [])

          if (_.isEmpty(options)) {
            return
          }

          filterQuery[attribute] = options
        }
      })

      return JSON.stringify(filterQuery)
    },
    registerFilter(payload) {
      this.registeredFilters.push(payload)
    },
    updateRegisteredFilter(payload) {
      const filterIndex = this.registeredFilters.findIndex((filter) => {
        return filter.attribute === payload.attribute
      })

      if (filterIndex > -1) {
        this.$set(this.registeredFilters, filterIndex, payload)
      }
    },
    applyFilter(payload) {
      this.updateRegisteredFilter(payload)
      const query = this.generateFilterQuery()
      this.$set(this.params, 'filter', query)

      this.fetchRewards()
    }
  },
}
